import moment from "moment";

import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

interface MedicalNoteAutosaveAlreadSignedOffWarningPopupProps {
    NoteModel: IPatientMedicalNoteModel;
}

class MedicalNoteAutosaveAlreadSignedOffWarningPopup extends React.Component<MedicalNoteAutosaveAlreadSignedOffWarningPopupProps, any> {
    private id: string = "medicalnoteautosavealreadsignedoffwarningpopup";

    public componentDidMount(): void {
        overlayStore.showOverlay(this.id);
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay(this.id);
    }

    public render(): JSX.Element {
        var signoffDate = this.props.NoteModel.get("AutosaveFailedSignoffDate");
        var signoffById = this.props.NoteModel.get("AutosaveFailedSignoffUser");
        var signoffBy = cacheStore.GetCliniciansPersonsByContactFacetId(signoffById);
        let signoffByName = (signoffBy != null) ? signoffBy.NameWithPrefix : "Id:" + signoffById;

        var title = cacheStore.GetString("WarningLabel");

        var msg = cacheStore.GetString("NoteAlreadySignedOff1Label");
        msg += " " + signoffByName + "(" + moment(signoffDate).format("YYYY-MM-DD HH:mm:SS") + " )";

        var autosaveNote = cacheStore.GetString("AutosaveAlreadySignedOffError");

        return (
            <Popup Id={this.id} title={title} closeTarget={LocalPatientOperations.MedicalNote.AutoSaveAlreadySignedOffWarningPopup_Ok} draggable={true} cssClass="memo">
                <div className="p-body">
                    <div>
                        <span> {msg} </span>
                    </div>
                    <div>
                        <span> <strong> {autosaveNote} </strong> </span>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button className="btn btn-default" onClick={this.ContinueNoteClick.bind(this)}>{cacheStore.GetString("OKLabel")} </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private ContinueNoteClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalNote.AutoSaveAlreadySignedOffWarningPopup_Ok);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { MedicalNoteAutosaveAlreadSignedOffWarningPopup };
